module.exports = __webpack_public_path__ + "img/mtel-no-bills.f4f9ca11.png";